import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { TutorialSessionQuestionService } from './tutorial-session-question.service';

@Injectable({
  providedIn: 'root'
})
export class TutorialSessionQuestionResolver implements Resolve<any> {

  constructor(private tutorialSessionQuestionService: TutorialSessionQuestionService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const id = route.paramMap.get('id');

    return this.tutorialSessionQuestionService.getTutorialSessionQuestion(id);
  //   return of({
  //     "token": null,
  //     "message": null,
  //     "data": {
  //       "sessionQuestionId": 15,
  //       "questionType": "TOPIC_TEST_QUESTION",
  //       "question": {
  //         "id": 196,
  //         "mark": 1,
  //         "question": "<p>The magnification of this electron micrograph is 5 x 10&sup3;. Assuming the measured length is 10mm, what is the actual size of the nucleolus?</p>\n<p>&nbsp;</p>\n<p><img src=\"046711eb-eac5-4eaf-9d31-945691d03a3c.png\" alt=\"\" /></p>",
  //         "rubric": null,
  //         "children": [],
  //         "curriculum_lobj_id": 353,
  //         "is_published": false,
  //         "answer_type": "MULTI_CHOICE",
  //         "question_code": 0,
  //         "question_order": 0,
  //         "estimated_time": 1,
  //         "answer_options": ["0.2�m", "0.5�m ", "2�m\t", "20�m"],
  //         "correct_answer_options": [2],
  //         "oeq_keywords": [],
  //         "question_file": "",
  //         "question_image": null,
  //         "answer_file": "",
  //         "answer_image": null,
  //         "cou_id": null,
  //         "is_past_exam_question": true,
  //         "change_status": "NO_CHANGE",
  //         "difficulty_level": "NONE",
  //         "curriculum_topic_notes_id": null,
  //         "base_type": "ct",
  //         "updated_at": "2022-01-21 13:11:16.788",
  //         "parent_id": null,
  //         "is_master": null,
  //         "question_year": 2008,
  //         "need_working": true,
  //         "examination_board": null
  //       }
  //     }
  //   })
  //   return of({
  //     "token" : null,
  //     "message" : null,
  //     "data" : {
  //       "sessionQuestionId" : 16,
  //       "questionType" : "SA_QUESTION",
  //       "question" : {
  //         "id" : 116,
  //         "question" : "During the preparation of temporary cell slides the sample must be:",
  //         "children" : [ ],
  //         "hint" : "You may have prepared a cell slide of an onion.",
  //         "curriculum_lobj_id" : 340,
  //         "is_published" : false,
  //         "answer_type" : "MULTI_CHOICE",
  //         "answer_options" : [ "Living", "Dead", "Either living or dead" ],
  //         "answer_options_tags" : null,
  //         "answer_options_competence" : null,
  //         "correct_answer_options" : [ 2 ],
  //         "answer_text" : null,
  //         "question_file" : "",
  //         "question_image" : null,
  //         "answer_file" : "",
  //         "answer_image" : null,
  //         "cou_right_id" : null,
  //         "cou_wrong_id" : null,
  //         "is_past_exam_question" : false,
  //         "resource_ids" : null,
  //         "change_status" : "NO_CHANGE",
  //         "difficulty_level" : null,
  //         "curriculum_lobj_notes_id" : null,
  //         "base_type" : "sa",
  //         "updated_at" : "2022-01-16 12:26:07.02",
  //         "parent_id" : null,
  //         "is_master" : false,
  //         "question_year" : 2022,
  //         "rubric" : null,
  //         "video_url" : "<p>Both living (e.g. onion cells, blood cells) and dead (e.g hair) can be visualised.</p>",
  //         "examination_board" : null
  //       }
  //     }
  //   })
  }
}
